import React, { useContext, useMemo } from 'react'
import { Col, Button } from 'react-bootstrap'
import objectPath from 'object-path'
import { TextField } from '@material-ui/core'
import { Search } from '@mui/icons-material'
import { DesignContext } from 'contexts/DesignContext'
import { ConfigContext } from 'contexts/ConfigContext'
import FeatherIcon from 'feather-icons-react'
import 'designer/styles/dynamic.css'
import { createDesignerData } from 'designer/component/action/Design'
import FormLoading from 'components/Loader/FormLoading'
import ModalComponent from 'designer/component/component/Modal'
import Title from '../title/Title'

const DYNAMIC_INDEX = -1

const CustomHeader = (props) => {
  let { uischema, children, config } = props
  let {
    addButton,
    editButton,
    filterPanel,
    filterList = [],
    addActionType,
    addAction,
  } = uischema
  let buttonKey = uischema.key

  let { dynamicIndex, dynamicName, isDynamic, isArray, arrayName } = config

  const fieldName = isArray
    ? `@${arrayName}.${uischema.name}`
    : isDynamic
    ? `${dynamicName}.${dynamicIndex}.${uischema.name}`
    : uischema.name
  const fieldKey = isArray
    ? `@${arrayName}.${uischema.key}`
    : isDynamic
    ? `${dynamicName}.${dynamicIndex}.${uischema.key}`
    : uischema.key

  const placeholder = useMemo(() => {
    if (!filterList || filterList.length === 0) return ''
    let labels = []
    filterList.forEach(({ label }) => labels.push(label))
    return labels.join(', ')
  }, [filterList])

  const designContext = useContext(DesignContext)
  const {
    jsonForm,
    setFormData,
    setIsAddDynamic,
    isLoading,
    isAddDynamic,
    setKeywordFilter,
    elementAction,
    setUischema,
    setOpenModal,
    setDesignerPropsData,
    findUischemaIndex,
    searchData,
  } = designContext
  const { formData = {}, designerPropsData = {} } = jsonForm
  const configContext = useContext(ConfigContext)
  const { layoutType } = configContext.state
  const isOpenModal = designContext.openModal

  const isLocked = objectPath.get(elementAction, ['isLockedEdit'])
  let hasEnable = objectPath.has(elementAction, ['isEnable', uischema.key])
  let isEnable = hasEnable
    ? objectPath.get(elementAction, ['isEnable', uischema.key])
    : true

  const addPanel = () => {
    if (addActionType === 'modal') {
      openModal(addAction)
    } else {
      let dynamicData = objectPath.get(formData, uischema.name) || []
      if (Array.isArray(dynamicData)) {
        let length = dynamicData.filter(
          (item) => objectPath.get(item, '@isDeleted') !== 1,
        ).length
        let seq = length + 1
        objectPath.push(formData, uischema.name, { [`@seq`]: seq })
        setFormData(formData)
        setIsAddDynamic(uischema.key)
      }
    }
  }

  const getModal = (form, modalKey) => {
    let elements = form.uischema.elements
    let mapKey = form.schema.mapKey[modalKey]
    let indices = findUischemaIndex(modalKey, mapKey, elements)
    let modalElement = indices.reduce((o, i) => o.elements[i], { elements })
    return modalElement
  }

  const openModal = async (action = {}) => {
    let modalKey = objectPath.get(action, 'modal.key')
    if (action.modalType === 'internal') {
      let elements = jsonForm.uischema.elements
      let modalElement = getModal(jsonForm, modalKey)
      modalElement.isOpen = true
      let newUiSchema = jsonForm.uischema
      newUiSchema.elements = elements
      setUischema(newUiSchema)
      setOpenModal(uischema.modal)
    } else if (action.modalType === 'external') {
      objectPath.set(designerPropsData, 'modal', action.formCode)
      let newDesignerPropsData = createDesignerData(
        designerPropsData,
        searchData,
        formData,
      )
      setDesignerPropsData(newDesignerPropsData)
      setOpenModal(buttonKey)
    } else if (action.modalType === 'component') {
      objectPath.set(designerPropsData, 'modal', action.component)
      setDesignerPropsData(designerPropsData)
    }
  }

  const colorByTheme = useMemo(
    () => (layoutType === 'dark' ? '#adb7be' : '#495057'),
    [],
  )

  if (!uischema.title) {
    return (
      <div
        style={{
          height: '100%',
          maxHeight: uischema.maxHeight ?? 'auto',
          overflowY: 'auto',
        }}
      >
        {!isLocked && addButton && isEnable && (
          <Button
            id={`${fieldKey}-add-panel`}
            className="ml-2 px-2 py-0"
            variant="outline-primary"
            onClick={addPanel}
            disabled={editButton ? isAddDynamic : false}
          >
            <FeatherIcon icon="plus" size="14" />
          </Button>
        )}
        {filterPanel && (
          <Col>
            <TextField
              id={`${fieldKey}-search`}
              placeholder={`ค้นหาด้วย ${placeholder}`}
              InputProps={{
                endAdornment: <Search className="text-secondary" />,
              }}
              onChange={(e) => setKeywordFilter(e.target.value)}
            />
          </Col>
        )}
        {isLoading ? (
          <div className="w-100">
            <FormLoading height="250" />
          </div>
        ) : (
          <>{children}</>
        )}
        {isOpenModal === buttonKey && (
          <ModalComponent
            ui={uischema}
            modalAction={addAction}
            isOpenModal={isOpenModal === buttonKey}
            modalDynamicIndex={DYNAMIC_INDEX}
            designerPropsData={jsonForm.designerPropsData}
            dynamicKey={uischema.key}
          />
        )}
      </div>
    )
  }

  return (
    <div
      style={{
        height: '100%',
        maxHeight: uischema.maxHeight ?? 'auto',
        overflowY: 'auto',
      }}
    >
      <fieldset className="scheduler-border row" id={fieldKey}>
        <legend
          className="scheduler-border"
          style={{
            fontSize: uischema.fontSize || '16px',
            color: colorByTheme,
            fontWeight: uischema.fontWeight,
          }}
        >
          <Title {...props} />
          {!isLocked && addButton && isEnable && (
            <Button
              id={`${fieldKey}-add-panel`}
              className="ml-2 px-2 py-0"
              variant="outline-primary"
              onClick={addPanel}
              disabled={editButton ? isAddDynamic : false}
            >
              <FeatherIcon icon="plus" size="14" />
            </Button>
          )}
        </legend>
        {filterPanel && (
          <Col>
            <TextField
              id={`${fieldKey}-search`}
              placeholder={`ค้นหาด้วย ${placeholder}`}
              InputProps={{
                endAdornment: <Search className="text-secondary" />,
              }}
              onChange={(e) => setKeywordFilter(e.target.value)}
            />
          </Col>
        )}
        {isLoading ? (
          <div className="w-100">
            <FormLoading height="250" />
          </div>
        ) : (
          <>{children}</>
        )}
        {isOpenModal === buttonKey && (
          <ModalComponent
            ui={uischema}
            modalAction={addAction}
            isOpenModal={isOpenModal === buttonKey}
            modalDynamicIndex={DYNAMIC_INDEX}
            designerPropsData={jsonForm.designerPropsData}
            dynamicKey={uischema.key}
          />
        )}
      </fieldset>
    </div>
  )
}

export default CustomHeader
